import { AccountServiceBase } from "../../config";
import { checkResponseErrors, makeRequestInit } from '../fetchHelper';
import { CustomerData } from "./CustomerData";
import type { Authentication } from "../auth/Authentication";
import type { ICustomerData } from "./server/model/ICustomerData";

export class CustomerEndpoints {
    private _auth: Authentication;

    constructor(auth: Authentication) {
        this._auth = auth;
    }

    _dofetch(url: string, init: RequestInit) {
        return this._auth
            .fetch(AccountServiceBase + url, init)
            .then(checkResponseErrors);
    }

    getCustomer() {
        const init = makeRequestInit('GET');
        return this._dofetch('/customer', init)
            .then(rsp => rsp.json())
            .then(json => new CustomerData(json));
    }
}
